import React from 'react';
import BadgeStatus from '../common/BadgeStatus';
import '../../styles/Table.css';

const CheckinAssetsTable = ({ assets, onRemove }) => {
  if (!assets || assets.length === 0) {
    return null;
  }

  return (
    <div className="checkin-assets-table">
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #e2e8f0' }}>
              <th style={{ textAlign: 'left', padding: '10px', fontSize: '11px', fontWeight: 600, color: '#718096' }}>Tag ID</th>
              <th style={{ textAlign: 'left', padding: '10px', fontSize: '11px', fontWeight: 600, color: '#718096' }}>Description</th>
              <th style={{ textAlign: 'left', padding: '10px', fontSize: '11px', fontWeight: 600, color: '#718096' }}>Status</th>
              <th style={{ textAlign: 'left', padding: '10px', fontSize: '11px', fontWeight: 600, color: '#718096' }}>Assigned To</th>
              <th style={{ textAlign: 'left', padding: '10px', fontSize: '11px', fontWeight: 600, color: '#718096' }}>Site</th>
              <th style={{ textAlign: 'left', padding: '10px', fontSize: '11px', fontWeight: 600, color: '#718096' }}>Department</th>
              <th style={{ textAlign: 'left', padding: '10px', fontSize: '11px', fontWeight: 600, color: '#718096' }}>Location</th>
              <th style={{ textAlign: 'center', padding: '10px', fontSize: '11px', fontWeight: 600, color: '#718096', width: '100px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {assets.map((asset) => {
              const assetId = asset.id || asset._id;
              return (
                <tr key={assetId} style={{ borderBottom: '1px solid #e2e8f0' }}>
                  <td style={{ padding: '10px', fontWeight: 600, color: '#2d3748', fontSize: '13px' }}>
                    {asset.assetTag || asset.tag || 'N/A'}
                  </td>
                  <td style={{ padding: '10px', color: '#4a5568', fontSize: '13px' }}>
                    {asset.description || 'N/A'}
                  </td>
                  <td style={{ padding: '10px' }}>
                    <BadgeStatus status={asset.status || 'assigned'} />
                  </td>
                  <td style={{ padding: '10px', color: '#718096', fontSize: '13px' }}>
                    {asset.assignedTo?.name || 'N/A'}
                  </td>
                  <td style={{ padding: '10px', color: '#718096', fontSize: '13px' }}>
                    {asset.location?.site?.name || 'N/A'}
                  </td>
                  <td style={{ padding: '10px', color: '#718096', fontSize: '13px' }}>
                    {asset.location?.department?.name || 'N/A'}
                  </td>
                  <td style={{ padding: '10px', color: '#718096', fontSize: '13px' }}>
                    {asset.location?.locationDetail || 'N/A'}
                  </td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    <button
                      onClick={() => onRemove && onRemove(assetId)}
                      style={{
                        padding: '4px 10px',
                        background: '#fed7d7',
                        color: '#c53030',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '11px',
                        fontWeight: 500
                      }}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CheckinAssetsTable;
